import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState, } from 'react';
import { AddressInformationsInitialState, } from '../../../features/entities';
import { getComponent, getLongAddress, getShortAddress, getShortComponent, } from '../../../features/helpers/get-address';
import { useTranslations } from '../../../features/providers/translations-provider';
import { StyledCustomInput } from '../custom-input/styles';
const GoogleAutocomplete = ({ form, setCanada, disabled, onAddressChange, cityOnly, completeAddressFieldName = 'complete', }) => {
    const { t } = useTranslations();
    const input = useRef(null);
    const autocompleteRef = useRef(null);
    const onAddressChangeRef = useRef(onAddressChange);
    const [value, setValue] = useState(form.getFieldValue(completeAddressFieldName));
    useEffect(() => {
        onAddressChangeRef.current = onAddressChange;
    }, [onAddressChange]);
    useEffect(() => {
        setTimeout(() => {
            setValue(form.getFieldValue(completeAddressFieldName));
        }, 500);
    }, [completeAddressFieldName, form]);
    const onPlaceSelected = useCallback((address, geometry) => {
        var _a, _b, _c;
        if (!!address) {
            const addressInfos = Object.assign(Object.assign({}, AddressInformationsInitialState), { address: [
                    getComponent(address, 'street_number'),
                    getComponent(address, 'route'),
                ]
                    .filter(Boolean)
                    .join(' '), city: getComponent(address, 'locality') ||
                    getComponent(address, 'postal_town'), country: getComponent(address, 'country'), province: getShortComponent(address, 'administrative_area_level_1'), postal_code: getComponent(address, 'postal_code') });
            const short = getShortAddress(addressInfos);
            const completeAddress = getLongAddress(short, {
                city: addressInfos.city,
                address: short,
                country: addressInfos.country,
                postal_code: addressInfos.postal_code,
                province: addressInfos.province,
            });
            setValue(completeAddress);
            setCanada(addressInfos.country == 'Canada');
            form.setFieldsValue({
                address: getShortAddress(addressInfos),
                city: addressInfos.city,
                country: addressInfos.country,
                isCanada: addressInfos.country == 'Canada',
                province: addressInfos.province,
                postal_code: addressInfos.postal_code,
                lng: (_a = geometry.location) === null || _a === void 0 ? void 0 : _a.lng(),
                lat: (_b = geometry.location) === null || _b === void 0 ? void 0 : _b.lat(),
                [completeAddressFieldName]: completeAddress,
            });
            (_c = onAddressChangeRef.current) === null || _c === void 0 ? void 0 : _c.call(onAddressChangeRef);
        }
    }, [completeAddressFieldName, form, setCanada]);
    useEffect(() => {
        var _a, _b;
        if (!input.current)
            return;
        const canadaBounds = {
            north: 83.3362128,
            south: 41.6765556,
            east: -52.3231981,
            west: -141.00187,
        };
        const options = {
            bounds: canadaBounds,
            fields: ['address_components', 'geometry', 'icon', 'name'],
            strictBounds: false,
            componentRestrictions: { country: ['ca', 'us', 'fr'] },
            types: cityOnly ? ['(cities)'] : ['street_address', 'locality'],
        };
        const autocomplete = (_a = autocompleteRef.current) !== null && _a !== void 0 ? _a : new google.maps.places.Autocomplete(input.current, options);
        autocompleteRef.current = autocomplete;
        autocomplete.setTypes((_b = options.types) !== null && _b !== void 0 ? _b : []);
        const listener = autocomplete.addListener('place_changed', async () => {
            var _a, _b;
            const place = autocomplete.getPlace();
            onPlaceSelected((_a = place.address_components) !== null && _a !== void 0 ? _a : [], (_b = place.geometry) !== null && _b !== void 0 ? _b : {});
        });
        return () => listener.remove();
    }, [cityOnly, onPlaceSelected]);
    const onChange = ({ target: { value } }) => {
        form.setFieldValue(completeAddressFieldName, value);
        setValue(value);
    };
    return (_jsx(StyledCustomInput, { className: "ant-input ant-input-lg", ref: input, onChange: onChange, value: value, disabled: disabled, placeholder: cityOnly
            ? t('profile|profileForm.address.placeholder.city')
            : t('profile|profileForm.address.placeholder.addressComplete'), onKeyDown: (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
            }
        }, onSubmit: (e) => {
            e.preventDefault();
            onAddressChange === null || onAddressChange === void 0 ? void 0 : onAddressChange();
        } }));
};
export default GoogleAutocomplete;
